import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { type VariantProps } from 'class-variance-authority';
import { Toggle as TogglePrimitive } from 'radix-ui';

import { toggleVariants } from './variants.js';

function Toggle({
  className,
  size,
  icon,
  ...props
}: React.ComponentProps<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants>) {
  return (
    <TogglePrimitive.Root
      data-slot="toggle"
      className={cn(toggleVariants({ size, icon, className }))}
      {...props}
    />
  );
}

export { Toggle };
